import { Injectable } from '@angular/core';
import { BaseService, httpOptions } from '@core/service/base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StorageLocationService extends BaseService{
  constructor(http: HttpClient) {
    super(http);
  }
  private url = 'api/storage-location';

  getUrl(): string {
    return this.url;
  }

  // getByCode(params: HttpParams): Observable<any> {
  //   const url = `${this.getUrl()}/find-by-code`;
  //   return this.http.get(url,
  //     {
  //       headers: httpOptions.headers,
  //       observe: 'response',//完整数据返回，包括抬头
  //       params: params,
  //     },
  //   ).pipe(
  //     tap(() => this.log('query object')),
  //     catchError(this.handleError('get any', [])),
  //   );
  // }

  getByCode(code,plantid):Observable<any> {
    const url = `${this.getUrl()}/get-by-code/`+code+'/'+plantid;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getWithItemList`)),
      catchError(this.handleError<any>(`getWithItemList`))
    );
  }



}
